import { render, staticRenderFns } from "./of_tinymce_readonly.vue?vue&type=template&id=2fa5104b&scoped=true&"
import script from "./of_tinymce_readonly.vue?vue&type=script&lang=js&"
export * from "./of_tinymce_readonly.vue?vue&type=script&lang=js&"
import style0 from "./of_tinymce_readonly.vue?vue&type=style&index=0&id=2fa5104b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5104b",
  null
  
)

export default component.exports